import { AxiosResponse } from 'axios';
import { useCallback } from 'react';
import { useQuery } from 'react-query';
import API from '../api';
import { PopUpTargetBranch } from '../types/popupTargetBranch';

export const usePopUpTargetBranch = (branchId: string | null) => {
  const { data, isLoading } = useQuery(
    ['popUpTargetBranch', branchId],
    async () => await API.getPopUpTargetBranch(branchId!),
    {
      enabled: !!branchId,
      select: useCallback((data: AxiosResponse<PopUpTargetBranch>) => {
        return data.data;
      }, []),
    }
  );

  return {
    targetBranch: data,
    isLoading,
  };
};
